export const LEAD_STATUSES = [
    'new',
    'contacted',
    'replied',
    'meeting',
    'customer',
    'team',
    'partnership',
    'rejected',
];
export const LEAD_STATUS_LABELS = {
    new: 'Nieuw',
    contacted: 'Benaderd',
    replied: 'Reactie',
    meeting: 'Gesprek',
    customer: 'Klant',
    team: 'Team',
    partnership: 'Samenwerking',
    rejected: 'Afgewezen',
};
//# sourceMappingURL=leadStatus.js.map